import React from "react";
import activeConsent from "../../../images/AG Dashboard/activeConsent.svg";
import expired from "../../../images/AG Dashboard/expired.png";
import recvokedConsent from "../../../images/AG Dashboard/revokedConsent.svg";
import cancel from "../../../images/AG Dashboard/cancel.png";
import orderHistory from "../../../images/AG Dashboard/order-history.png";
import ending from "../../../images/AG Dashboard/pending.svg";

function AccountAggCard({
  name,
  image,
  active,
  rejected,
  revoked,
  expiredConsent,
  pending,
}) {
  return (
    <div className=" w-[32%] rounded-lg border border-[#e2ecff]  h-[325px] p-4">
      <div className=" flex items-center border-b border-[#e2ecff] pb-3 h-[58px]">
        <img
          src={image}
          alt="AA"
          width={
            name === "CAMS AA Finserv" || name === "Protean" || name === "NADL"
              ? 60
              : 46
          }
          className="rounded-full object-contain "
        />
        <p className=" font-semibold text-base ml-4">{name}</p>
      </div>
      <div className=" w-[97%]  mt-3 flex justify-between items-center">
        <div className=" w-[46%]  flex items-start h-[40px]">
          <img
            src={activeConsent}
            alt="active consent"
            width={14}
            height={14}
            className=" mt-[3px]"
          />
          <p className=" flex flex-col justify-between m-0 h-full leading-4 ml-2 ">
            <span className=" text-sm text-[#848484] font-medium">
              Active Consents
            </span>
            <span className=" text-base font-semibold">{active}</span>
          </p>
        </div>
        <div className=" w-[46%]  flex items-start h-[40px]">
          <img
            src={expired}
            alt="active consent"
            width={17}
            height={17}
            className=" mt-[3px]"
          />
          <p className=" flex flex-col justify-between m-0 h-full leading-4 ml-2 ">
            <span className=" text-sm text-[#848484] font-medium">
              Expired Consents
            </span>
            <span className=" text-base font-semibold">{expiredConsent}</span>
          </p>
        </div>
      </div>
      {/* //// */}
      <div className=" w-[95%]  mt-[32px] flex justify-between items-center">
        <div className=" w-[45%]  flex items-start h-[40px]">
          <img
            src={recvokedConsent}
            alt="active consent"
            width={12}
            height={16}
            className=" mt-[3px]"
          />
          <p className=" flex flex-col justify-between m-0 h-full leading-4 ml-2 ">
            <span className=" text-sm text-[#848484] font-medium">
              Revoke Consents
            </span>
            <span className=" text-base font-semibold">{revoked}</span>
          </p>
        </div>
        <div className=" w-[45%]  flex items-start h-[40px]">
          <img
            src={cancel}
            alt="active consent"
            width={16}
            height={16}
            className=" mt-[3px]"
          />
          <p className=" flex flex-col justify-between m-0 h-full leading-4 ml-2 ">
            <span className=" text-sm text-[#848484] font-medium">
              Rejected Consents
            </span>
            <span className=" text-base font-semibold">{rejected}</span>
          </p>
        </div>
      </div>
      {/* /// */}
      <div className=" w-[95%]  mt-[32px] flex justify-between items-center">
        <div className=" w-[45%]  flex items-start h-[40px]">
          <img
            src={orderHistory}
            alt="active consent"
            width={17}
            height={17}
            className=" mt-[3px]"
          />
          <p className=" flex flex-col justify-between m-0 h-full leading-4 ml-2 ">
            <span className=" text-sm text-[#848484] font-medium">
              Pending Consent Request
            </span>
            <span className=" text-base font-semibold">{pending}</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default AccountAggCard;
